module.exports = __webpack_public_path__ + "media/src/images/site-top/icon-fukui-sm-4665d69d4bbc2a303e5a516fa84bfec0.png";